import { PageLocaleEnum } from 'common/enums/PageLocaleEnum'
import { TFunction } from 'i18next'
import React from 'react'
import { IconArrow } from '../icons/icon-arrow'
import { PricePlanPeriodType } from '../price-element-interface'
import {
  PriceElementPeriodBtnUi,
  PriceElementPeriodDescriptionUi,
  PriceElementPeriodDescriptionWrapperUi,
  PriceElementPeriodSavingIconUi,
  PriceElementPeriodSavingTextUi,
  PriceElementPeriodSavingUi,
  PriceElementPeriodSwitcherUi,
  PriceElementPeriodUi,
} from './ui'

interface CommonPriceElementPeriodProps {
  activeBtn: PricePlanPeriodType
  onClick: (value: PricePlanPeriodType) => void
  locale: PageLocaleEnum
  t: TFunction
  isLoading: boolean
}

export const CommonPriceElementPeriod = ({
  activeBtn,
  onClick,
  locale,
  isLoading,
  t,
}: CommonPriceElementPeriodProps) => {
  const handleClick = (period: PricePlanPeriodType) => {
    if (isLoading) {
      return false
    }
    onClick(period)
  }

  return (
    <PriceElementPeriodUi>
      <PriceElementPeriodDescriptionWrapperUi>
        <PriceElementPeriodDescriptionUi>
          {t('components.price_element.period.title')}
        </PriceElementPeriodDescriptionUi>
        <PriceElementPeriodSavingUi locale={locale}>
          <PriceElementPeriodSavingIconUi>
            <IconArrow />
          </PriceElementPeriodSavingIconUi>
          <PriceElementPeriodSavingTextUi locale={locale}>
            {t('components.price_element.period.additional_text')}
          </PriceElementPeriodSavingTextUi>
          {t('components.price_element.period.sub_additional_text')}
        </PriceElementPeriodSavingUi>
      </PriceElementPeriodDescriptionWrapperUi>
      <PriceElementPeriodSwitcherUi>
        <PriceElementPeriodBtnUi
          onClick={() => handleClick('monthly')}
          isActive={activeBtn === 'monthly'}
          isDisabled={isLoading}
        >
          {t('components.price_element.period.monthly')}
        </PriceElementPeriodBtnUi>
        <PriceElementPeriodBtnUi
          onClick={() => handleClick('annually')}
          isActive={activeBtn === 'annually'}
          isDisabled={isLoading}
        >
          {t('components.price_element.period.annually')}
        </PriceElementPeriodBtnUi>
      </PriceElementPeriodSwitcherUi>
    </PriceElementPeriodUi>
  )
}
